import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AudioLines, Printer, Mail, Pause, ChevronDown } from "lucide-react";
import Lottie from "lottie-react";
import background from "../../assets/background.json";
import logo from "../../logo.png";
import EmailDialog from "../../components/EmailDialog";
import audioFile from "../../assets/audio/audio1.wav";
import АжилдЭргүүлэнТогтоолг from "../../assets/audio/АжилдЭргүүлэнТогтоолг.wav";
import АжилласанЖилТогтоолго from "../../assets/audio/АжилласанЖилТогтоолго.wav";
import БусдХууБусЭзэмшГаЧөТу from "../../assets/audio/БусдХууБусЭзэмшГаЧөТу.wav";
import ГүйцХуудБичүүлэхХүсэ from "../../assets/audio/ГүйцХуудБичүүлэхХүсэ.wav";
import ГэрлЦуцХүүхАсрТэтГарХ from "../../assets/audio/ГэрлЦуцХүүхАсрТэтГарХ.wav";
import Гэрээнийүүрэг from "../../assets/audio/Гэрээний үүрэг.wav";
import ЗээлГэрээнийНэхэмжлэл from "../../assets/audio/ЗээлГэрээнийНэхэмжлэл.wav";
import НасБарсандТооцуулТуха from "../../assets/audio/НасБарсандТооцуулТуха.wav";
import НаТоТөрОнСарӨдЗөвтТух from "../../assets/audio/НаТоТөрОнСарӨдЗөвтТух.wav";
import НөхөнОлговорГаргууТу from "../../assets/audio/НөхөнОлговорГаргууТу.wav";
import ОронСууцӨмчлгчрТогтТу from "../../assets/audio/ОронСууцӨмчлгчрТогтТу.wav";
import СураггүйАлгБолсТоцуТу from "../../assets/audio/СураггүйАлгБолсТоцуТу.wav";
import УлсБүртгэлБүртгүүлТух from "../../assets/audio/УлсБүртгэлБүртгүүлТух.wav";
import ХамтАмьдБайснТогТухай from "../../assets/audio/ХамтАмьдБайснТогТухай.wav";
import ХүүхдТэтгэлэгГаргуула from "../../assets/audio/ХүүхдТэтгэлэгГаргуула.wav";
import ЭвлэЗуучӨргөдөлГаргах from "../../assets/audio/ЭвлэЗуучӨргөдөлГаргах.wav";
import ЭдХөрөнгөМөнГаргуулах from "../../assets/audio/ЭдХөрөнгөМөнГаргуулах.wav";
import ЭдХөУчрГэмХорТөлГарТу from "../../assets/audio/ЭдХөУчрГэмХорТөлГарТу.wav";
import ЭрхЗүйнЧадамжгТооцТу from "../../assets/audio/ЭрхЗүйнЧадамжгТооцТу.wav";
import ЭрэнСурвалжлах from "../../assets/audio/ЭрэнСурвалжлах.wav";

const DocumentTemplate = () => {
  const location = useLocation();
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const [showEmailDialog, setShowEmailDialog] = useState(false);

  const selectedOption = location.state?.selectedOption;
  const selectedSection = location.state?.selectedSection;
  const transcript = location.state?.transcript;
  const [activeSection, setActiveSection] = useState(
    selectedSection || "зээлийн"
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  

  const menus = [
    { name: "Төлбөрийн даалгавар үүсгэх", link: "https://itax.mta.mn/modules/invoice/create-receipt", isExternal: true },
    { name: "Албадан гүйцэтгэх хүсэлтийн загвар", link: "#", isExternal: true },
    { name: "Улсын тэмдэгтийн хураамж тооцоолох", link: "https://dundgovi-court.mn/site/fees", isExternal: true },
    { name: "Шүүх хурлын зар, тойм", link: "https://live.shuukh.mn/#gsc.tab=0", isExternal: true },
    { name: "Шүүхийн шийдвэрийн цахим сан", link: "https://shuukh.mn/", isExternal: true },
    { name: "Тусгайлсан журмаар хэрэг хянан шийдвэрлэх ажиллагаа ", link: "https://www.supremecourt.mn/mn/home?page=pages&id=201&pr=200&tp=list&h=0", isExternal: true }
  ];

  const handleMenuClick = (menu) => {
    if (menu.isExternal) {
      window.open(menu.link, "_blank", "noopener,noreferrer");
    } else {
      navigate(menu.link);
    }
    setShowDropdown(false);
  };



  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    audioRef.current = new Audio(sections[activeSection].audio);
    setIsPlaying(false);
  }, [activeSection]);

  // Effect to handle cleanup
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current || !sections[activeSection].audio) {
      console.warn('No audio available for this section');
      return;
    }
  
    try {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch(error => {
          console.error('Error playing audio:', error);
        });
      }
      setIsPlaying(!isPlaying);
    } catch (error) {
      console.error('Error toggling audio:', error);
    }
  };
  
  // Add event listeners for audio ending
  useEffect(() => {
    const handleAudioEnd = () => {
      setIsPlaying(false);
    };

    if (audioRef.current) {
      audioRef.current.addEventListener('ended', handleAudioEnd);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('ended', handleAudioEnd);
      }
    };
  }, [activeSection]);

  const handleEmailClick = () => {
    setShowEmailDialog(true);
  };

  const handlePrint = () => {
    const originalContent = document.body.innerHTML;
    const selectedSection = sections[activeSection];

    const printContent = `
      <div style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; padding: 30mm 15mm 20mm 30mm;">
        <div style="text-align: center; font-weight: bold; margin-bottom: 20px;">
          ${selectedSection.heading || ""}
        </div>
        <div style="white-space: pre-wrap;">
          ${selectedSection.content}
        </div>
      </div>
    `;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
  };

  const sections = {
    зээлийн: {
      title: "Зээлийн гэрээний нэхэмжлэл",
      heading:
        "Дундговь аймаг дахь Сум дундын анхан шатны шүүхэд нэхэмжлэл гаргах нь",
        audio: ЗээлГэрээнийНэхэмжлэл,
      content: `Огноо                                                       Сайнцагаан сум

Нэхэмжлэгч: Дундговь аймаг .... сум .... баг, .... дугаар байрны.......... йин ..... тоотод оршин суух, А овогтой Б Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/

Нэхэмжлэлийн шаардлага: Хариуцагчийг эрэн сурвалжлуулах тухай

Нэхэмжлэлийн үндэслэл: Миний бие Д.Тулгатай 2007 оны 02 дугаар сарын 15-нд зээлийн гэрээ байгуулж, 10.0 сая төгрөгийг сарын 5 хувийн хүүтэй, 3 сарын хугацаатай зээлдүүлсэн юм. Д.Тулга нь тухайн үед Булган сумын 3 дугаар баг Зг-7-15 тоотод оршин сууж, Хүнсний зах дээр махны ченж хийдэг байсан. Зээлийн гэрээ байгуулж мөнгөө зээлж авснаас хойш 2 сар хүүгээ төлөөд тэрнээс хойш огт мөнгө төлөөгүй. Эхэндээ 2 хоногийн дараа, 3 хоногийн дараа гээд л яваад байдаг байсан. Одоо хаана оршин сууж байгаа нь мэдэгдэхгүй байгаа учир Д.Тулгыг эрэн сурвалжилж оршин суугаа хаягийг нь тогтоож өгнө үү. Д.Тулгын эхнэр Орхон трейд ХХК-нд ажилладаг байсан. Төрсөн эгч нь 20-р 12 жилийн сургуульд багш хийдэг. Утас нь 99000000 гэсэн утастай. Иймд миний хүсэлтийг хангаж өгнө үү.

Нэхэмжлэлд хавсаргах баримт бичиг:
1. Нэхэмжлэл
2. Зээлийн гэрээ /гэх мэт/
3. Иргэний үнэмлэхийн хуулбар
4. Тухайн этгээдийн хамгийн сүүлд оршин сууж байсан газрын багийн Засаг даргын тодорхойлолт
5. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/

Дэлгэрэнгүй мэдээллийг тус шүүхийн мэдээлэл, лавлагааны
ажилтанаас авна уу. Шүүхийн үйлчилгээний хэлтэс

Утас: 7059-3016
Вэб сайт: http://www.dundgovi-court.mn

ЖИЧ:
1. Нэхэмжлэлээ гаргацтай, эмх цэгцтэй, уншигдах боломжтойгоор цэвэрхэн бичнэ үү.
2. Хавсаргасан материалыг дэс дугаарлаж бичнэ үү.

АНХААР: Та нотлох баримтуудыг нотариатаар гэрчлүүлсэн байх шаардлагатай ба нэхэмжлэлийг бичихдээ цаасны зүүн захаас 30мм, дээд, доод захаас 20мм, баруун захаас 15мм зайтай бичнэ үү.`,
    },
    ажилд: {
      title: "Ажилд эргүүлэн тогтоолгох",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ:",
        audio: АжилдЭргүүлэнТогтоолг,
      content: `Нэхэмжлэгч: ............... овогт ...................-ын ...................
Дундговь аймаг, ........... сум, ......... баг, ....... тоот
Утас:..................

Хариуцагч: "ААА" ХК
Дундговь аймаг ............ сум .......... баг, ......... тоот
Утас: ..................

Нэхэмжлэлийн шаардлага: Ажилд эргүүлэн тогтоолгох ажилгүй байсан хугацааны цалинг гаргуулах.

А.Б би ХХХХ оны ХХ дүгээр сарын ХХ-ны өдөр ААА ХК-тай хөдөлмөрийн гэрээг 1 жилийн хугацаатай хийж, менежирийн ажилд орсон. Хөдөлмөрийн гэрээний хугацаа дуусч ХХХХ оны ХХ дүгээр сарын ХХ-наас эхлэн ХХ оны ХХ дүгээр сарын ХХ-ны өдрийг хүртэл хөдөлмөрийн гэрээг 1 жилийн хугацаагаар үргэлжлүүлэн сунгасан. Гэтэл ХХХХ оны ХХ дүгээр сарын ХХ-ны өдөр 00/12 дугаартай захирлын тушаалаар сахилгын зөрчил гаргасан гэж надтай байгуулсан хөдөлмөрийн гэрээг цуцалж ажлаас халсан юм. Ажиллах хугацаандаа би ямар нэгэн зөрчил дутагдал гаргаж байгаагүйг хамт ажиллаж байсан хүмүүс бүгд мэднэ.

Иймд намайг ажлаас үндэслэлгүйгээр халсан тул .................................. тоот тушаалыг хүчингүй болгож, ............... намайг ........................ ХХК-ийн ........................ албан тушаалд эгүүлэн тогтоож, ажилгүй байсан хугацааны цалин ............... төгрөгийг гаргуулж, нийгмийн даатгал болон эрүүл мэндийн даатгалын дэвтэрт нөхөн бичилт хийлгэж өгнө үү.

Нэхэмжлэлд: /Хавсаргасан баримтын жагсаалтаа бичнэ үү. Мөн хуудсаа дугаарлана уу/
1. Нэхэмжлэл 2 хувь
2. Хөдөлмөрийн гэрээ
3. Ажилд орсон тушаал
4. Ажлаас халагдсан тушаал
5. Нийгмийн даатгалын дэвтрийн хуулбар нотариатаар гэрчлүүлсэн
6. Иргэний үнэмлэхний хуулбар нотариатаар гэрчлүүлсэн

/ Нотлох баримтыг эх хувиар нь өгөх боломжгүй бол нотариатаар гэрчлүүлсэн хуулбарыг гаргаж өгнө /

                   Нэхэмжлэл гаргасан: ..................... /А.Б........../`,
    },
    эвлэрүүлэн: {
      title: "Эвлэрүүлэн зуучлалд өргөдөл гаргах",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ АНХАН ШАТНЫ ШҮҮХ ДЭХ ЭВЛЭРҮҮЛЭН ЗУУЧЛАЛД ӨРГӨДӨЛ ГАРГАХ НЬ",
        audio: ЭвлэЗуучӨргөдөлГаргах,
      content: `1.Өргөдөл гаргагч:
  _____________________овогтой_________________________________
  /иргэн эсхүл түүний итгэмжлэгдсэн төлөөлөгч өргөдөл гаргасан бол иргэний үнэмлэхэд заасан овог нэр, хуулийн этгээд эсхүл хуулийн этгээдийн эрхгүй этгээд гаргасан бол эрхийн улсын бүртгэлийн гэрчилгээнд заасан оноосон нэр/
  
  ___________________________регистрийн дугаартай, _____________________ аймаг/хот,_________________сум/дүүрэг,_______________баг/хороо, __________________ хороолол,________________байр/гудамж,_________тоотод оршин суух/байрлах,
  
  _____________________________________харилцах утасны дугаар,
  _____________________________________цахим шуудан
  
  2.Өргөдөл гаргагчийн итгэмжлэгдсэн төлөөлөгч:
  _____________________________регистрийн дугаартай,_____________________ аймаг/хот,_________________сум/дүүрэг,_______________баг/хороо,__________________ хороолол,________________ байр/гудамж,_________ тоотод оршин суух
  _____________________харилцах утасны дугаар
  _____________________цахим шуудан
  
  3.Уригдагч тал:
  _____________________овогтой_________________________________
  /иргэн эсхүл түүний итгэмжлэгдсэн төлөөлөгч өргөдөл гаргасан бол иргэний үнэмлэхэд заасан овог нэр, хуулийн этгээд эсхүл хуулийн этгээдийн эрхгүй этгээд гаргасан бол эрхийн улсын бүртгэлийн гэрчилгээнд заасан оноосон нэр/
  
  _____________________регистрийн дугаартай,_____________________ аймаг/хот,________________сум/дүүрэг,_____________баг/хороо__________________ хороолол,_____________байр/гудамж,___________тоотод оршин суух/байрлах,
  
  _________________________________________харилцах утасны дугаар
  _________________________________________цахим шуудан
  
  Маргааны агуулга
  .............................................................................................
  .............................................................................................
  .............................................................................................
  маргааныг эвлэрүүлэн зуучлах ажиллагааны журмаар шийдвэрлүүлэхээр энэхүү өргөдлийг гаргаж байна.
  
              Өргөдөл, түүнд хавсаргасан баримт:
              1.Өргөдөл ..... хувь, .....хувь тус бүр .......хуудас, нийт......... хуудас;
              2.Улсын тэмдэгтийн хураамж төлсөн баримт ... хуудас;
              3.Иргэний үнэмлэхийн хуулбар;
              4.Итгэмжлэлгүй төлөөлөх эрхтэйг нотлох баримт..........хуудас
              /хуулийн этгээд, хуулийн этгээдийн эрхгүй этгээд өргөдөл гаргасан бол/
              5. Итгэмжлэл..............хуудас
              /итгэмжлэгдсэн төлөөлөгч гаргасан бол/
              6.................................................................
              Бүгд ..... хуудас болно.
  
              Өргөдөл гаргасан:________________/____________________/
                                                                         /Гарын үсэг/                                /Гарын үсгийн тайлал/
              /иргэн, хуулийн этгээд, хуулийн этгээдийн эрхгүй этгээдийг итгэмжлэлгүйгээр төлөөлөх этгээд эсхүл тэдгээрийн итгэмжлэгдсэн төлөөлөгч гарын үсэг зурна/
  
              Өргөдөл гаргагчийн
              итгэмжлэгдсэн төлөөлөгч:________________ /____________________/
                                                                                        /Гарын үсэг/                                /Гарын үсгийн тайлал/
  
  Жишээ:
  Дундговь аймаг дахь анхан
  шатны шүүх дэх эвлэрүүлэн зуучлалд
  
  Өргөдөл гаргах нь:
  
  ..... он .....сар .... өдөр                                                                                                                                           Сайнцагаан сум
  
  Өргөдөл гаргагч: Халх овогт Хадааны Саранчулуу
  Хаяг: Сэлэнгэ аймаг ............. сумын 2 дугаар баг, Шинэ худаг гэх газар нутаглах, утас 91хххххх
  
  Тайлбар гаргагч: Боржигон овогт Уулын Төмөр
  Хаяг: Дундговь аймгийн ................  сумын 2 дугаар баг, Чулуут гэх газар нутаглах, утас 91хххххх
  
         Маргааны агуулга:
         У.Төмөр миний бие 2014 онд У.Төмөртэй танилцаж, 2016 онд гэрлэлтээ батлуулсан. Гэр бүлийн амьдрал зохиосноос хойш жил дараалан хүүхэд төрүүлж, 5-6 насны охин хүүтэй болцгоосон. Амьдралын эхний жилүүдэд харилцаа таарамжтай, үл ойлголцох зүйл гардаггүй байсан ч хүүхдүүдээ төрүүлснээс хойш нөхрийн ааш зан өөрчлөгдөж, үл ойлголцох байдал их үүсдэг болсон.
  
        Өөрсдийн гэсэн амьжиргааны хэдэн малтай, түүнийхээ үр шимээр боломжийн сайн амьдардаг ч нөхөр маань мөрийтэй тоглоомд донтой болсоор амьжиргааны эх үүсвэрээ ч үгүй хийх дээрээ хүрээнд байна. Энэ байдлын талаар харилцан ярилцсан ч буруутай үйлдлээ хүлээн зөвшөөрөхгүй, маргаан үүсгэж гэр орныхоо эд зүйлд халдаж, гар хүрэх тохиолдолд үүсэх боллоо. Өдөр ирэх бүр бидний байдал сайжрах биш дордсоор байна. Иймд миний бие гэрлэлт цуцлуулах хүсэлттэй байгаа тул хүсэлтийг хүлээн авч шийдвэрлэж өгнө үү.
  
       Хавсаргасан баримт
       Өргөдөл
       Гэрлэлтийн баталгааны хуулбар
       Улсын тэмдэгтийн хураамж төлсөн баримт
  
                             Өргөдөл гаргагч ...................................`,
    },
    гэрлэлт: {
      title: "Гэрлэлт цуцлуулж, хүүхдийн асрамж, тэтгэлэг гаргуулах хүсэлт",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ГэрлЦуцХүүхАсрТэтГарХ,
      subheading:
        "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                       Сайнцагаан сум
  
  Нэхэмжлэгч: Сэлэнгэ аймаг .... сум ...-р баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Хариуцагч: Сэлэнгэ аймаг .... сум ...-р баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Гэрлэлт цуцлуулж, хүүхдийн асрамж тогтоолгож, тэтгэлэг гаргуулах, эд хөрөнгө хуваалгах тухай
  
  Нэхэмжлэлийн үндэслэл: А овогтой Б миний бие нь 1990 онд Д овогтой Г-тэй танилцан улмаар 1994 оны 10 дугаар сарын 01-нд гэрлэлтийн ...... тоот баталгаагаар бүртгүүлж гэр бүл болсон билээ. Бидний хамтран амьдрах хугацаанд 1992 оны 10 дугаар сарын 01-ний өдөр хүү Г.Д, 1996 оны 10 дугаар сарын 01-ний өдөр охин Г.Г нар төрсөн. Бид зан харьцааны таарамжгүй байдлын улмаас цаашид хамтран амьдрах боломжгүй болж 2000 оноос салж тусдаа амьдрах болсон юм. Тэр үеэс хойш хүү охин хоёр маань эх Д.Г-ийн асрамжид амьдарч өсөж торнисон. Одоо бид тус тусын амьдралтай болсон, цаашид хамтран амьдрах боломжгүй болсон тул бидний гэрлэлтийг цуцалж өгнө үү. Хүү Г.Д, охин Г.Г нарыг миний асрамжид үлдээж, эцэг Д.Г-ээс хүүхдийн тэтгэлэг гаргуулж өгнө үү. Бидний дундын өмчлөлийн эд хөрөнгө болох Хан-Уул дүүргийн ХХ-р хороо ХХ-р байр ХХ тоот .... өрөө байр, Pajero маркийн суудлын автомашинаас надад болон 2 хүүхдэдээ ногдох хэсгийг гаргуулах хүсэлтэй байна.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  
  1. Нэхэмжлэл 2 хувь
  2. Багийн Засаг даргын тодорхойлолт /ам бүлийн/
  3. Гэрлэлтийн баталгааны хуулбар /нотариатаар баталгаажуулсан/
  4. Хүүхдүүдийн төрсний гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  5. Бага насны хүүхдийн эрүүл мэнд өсөн бойжиж буй эмнэлгийн магадлагаа, сургуулийн тодорхойлолт
  6. Хуваалгах эд хөрөнгийн гэрчилгээнүүдийн хуулбар /нотариатаар баталгаажуулсан/
  7. Иргэний үнэмлэхийн хуулбар /нотариатаар баталгаажуулсан/
  8. Улсын тэмдэгтийн хураамж төлсөн баримт
  
  Шүүхийн үйлчилгээний хэлтэс`,
    },
    үүрэг: {
      title: "Гэрээний үүрэг",
      heading:
        "ДУНДГОВЬ АЙМГИЙН СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ:",
        audio: Гэрээнийүүрэг,
      content: `Сайнцагаан сум                                                                                                    2023 он
  
  Нэхэмжлэгч: .............. овогт ..............-ын ....................... 
  Хаяг: Дундговь аймгийн .............. сум ......... дугаар баг ............. тоот оршин суух
  Утас:.......
  
  Хариуцагч: ................. овогт ................-ын ............................. 
  Хаяг: Дундговь аймгийн .............. сум .... дугаар баг ................. тоот оршин суух 
  Утас:
  
  Нэхэмжлэлийн шаардлага: ...................... төгрөг гаргуулах тухай
  
       .............................................................................................
  ...................................................................................................
  ...................................................................................................
  
  Иймд .............-с .............. төгрөг гаргуулж өгнө үү.
  
                            Нэхэмжлэл гаргасан: ..................`,
    },
    хамтын: {
      title: "Хамтын амьдралтай байсныг тогтоолгох тухай",
      heading: "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН ШҮҮХЭД ХҮСЭЛТ ГАРГАХ НЬ:",
      audio: ХамтАмьдБайснТогТухай,
      content: `....оны....-р сарын....-ны өдөр
  
  Хүсэлт гаргагч: ................ овогт ..................-ын .......................
  Дундговь аймаг ................. сум ................. баг тоот
  Утас:хххххххх
  
  Нэхэмжлэлийн шаардлага: Хамтын амьдралтай байсныг тогтоолгох тухай
  
      ............. миний бие өөрийн нөхөр/эхнэр болох .....................-тэй 1995 оноос хойш хамт амьдарч 4 хүүхэд өсгөн хүмүүжүүлсэн Бид хоёр олон жил хамтран амьдарч байгаа боловч гэрлэлтээ албан ёсоор батлуулаагүй өдий хүрсэн. Ингээд би малчны тэтгэвэрт гарах гэсэн боловч малын А данс нөхрийн нэр дээр байгаа учир хамтран амьдарч байснаа шүүхийн шийдвэрээр тогтоолгох хүсэлтэй байна.
  
  Иймд ................. намайг .................... тэй 1990 оноос хойш хамтын амьдралтай байсныг тогтоож өгнө үү.
  
  Хавсаргасан материал:
  1. Хүсэлт 1 хувь
  2. Гэрч асуулгах хүсэлт
  3. Улсын тэмдэгтийн хураамж төлсөн /70200 төгрөг /баримт
  4. Иргэний үнэмлэхний хуулбар 1 хуудас
  5. Өрхийн бүртгэлийн дэвтэр
  6. Багийн даргын тодорхойлолт
  7. архивын лавлагаа /хүн амын тооллогын/
  8. Хүүхдүүдийн төрсний гэрчилгээ
  
  
                           Хүсэлт гаргасан............... /`,
    },
    ажилласанЖил: {
      title: "Ажилласан жил тогтоолгох",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: АжилласанЖилТогтоолго,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                      Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Улсад ажилласан жил тогтоолгох тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие анх 1976 оны 06 дугаар сарын 10-ны өдөр Сэлэнгэ аймгийн мод боловсруулах үйлдвэрт нормчноор ажилд орсон. Ингээд ажиллаж байгаад 1978 оны 12 сард мужааны цехэд шилжин ажилласан. Мужаан цехэд тасралтгүй 09 жил ажилласан. 1988 онд өөрийн охин Цэцгийг төрүүлэн жирэмсний амралтаа аваад 1989 онд ажилдаа эргэн орсон. 1990 онд өөрийн хүсэлтээр ажлаасаа гарсан. Тухайн үед хөдөлмөрийн дэвтэр нээлгэн ажиллаж байсан боловч мод боловсруулах үйлдвэрийн боловсон хүчин миний хөдөлмөрийн дэвтрийг үрэгдүүлсэн тул намайг 1976 оны 06 сарын 10-ны өдрөөс 1988 оны 12-р сарын 31-ны өдөр хүртэл мод боловсруулах үйлдвэрт нормчноор ажиллаж байсныг тогтоож өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Тухайн байгууллагад ажилд орсон, гарсан тушаал эсхүл архивын лавлагаа
  3. Баярын бичиг /ажиллаж байсан хугацааны/
  4. Үйлдвэрчний эвлэлийн батлах
  5. Ажиллаж байсныг нотлох бусад баримт бичиг
  6. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар /нотариатаар баталгаажуулсан/
  7. Гэрч нарын тодорхойлолт /тодорхойлолт бичсэн хүний иргэний үнэмлэхийг тодорхойлолт дээр хуулбарлаж нотариатаар баталгаажуулсан байх/
  8. Гэрч нарыг тухай байгууллагад ажиллаж байсныг нотлох баримт /тушаал, хөдөлмөрийн дэвтэр, нийгмийн даатгалын дэвтрийн хуулбар гэх мэт/
  9. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас:7059-3016`,
    },
    гүйцэтгэх: {
      title: "Гүйцэтгэх хуудас бичүүлэх хүсэлт",
      heading: "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН ШҮҮХЭД ХҮСЭЛТ ГАРГАХ НЬ:",
      audio: ГүйцХуудБичүүлэхХүсэ,
      content: `20.... ...  .....                                                                                                  Сайнцагаан сум
  
  Хүсэлт гаргах тухай
  
          Дундговь аймгийн ................................. шүүхийн ....... оны .... сарын ......-ны/ний/ өдрийн ....... тоот захирамжаар, шийдвэрээр /доогуур зурах/ хариуцагч ......................................................... /иргэн, хуулийн этгээд/ ............................................................................................. төгрөг гаргуулж нэхэмжлэгч .................................................д олгохоор шийдвэрлэсэн.
  
  Хариуцагч ................................................................. нь шүүхийн шийдвэр, магадлал /захирамж/-ийг сайн дураараа биелүүлэхгүй байх тул гүйцэтгэх хуудас бичиж өгнө үү.
  
  Тус шүүхийн ............. оны ........ сарын .........-ны өдрийн ....... тоот /шийдвэр, захирамж/-ийг хавсаргав.
  
  
  
                    Хүсэлт гаргасан .............                           `,
    },
    оронСууц: {
      title: "Орон сууцны өмчлөгчөөр тогтоолгох тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ОронСууцӨмчлгчрТогтТу,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                              Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Орон сууцны өмчлөгчөөр тогтоолгох тухай
  
  Нэхэмжлэлийн үндэслэл: Иргэн Н.М миний бие 2007 оны 03 дугаар сарын 29-ний өдөр ...... ХХКомпанитай орон сууцны барилгаас нь захиалгаар байр худалдан авах гэрээг байгуулж, Хан-Уул дүүргийн 2 дугаар хорооны нутаг дэвсгэрт ...... орон сууц үйлчилгээний хотхоны 136 айлын орон сууцны барилгаас 50м2 талбай бүхий 2 өрөө орон сууцыг 1м2 талбайг 450 доллароор тооцож бүгд 22500 доллароор худалдан авахаар болсон. Гэрээ хийсэн өдрөө төлбөрийн 40% болох 9000 /есөн мянган/ ам долларыг төлсөн. Уг барилгыг 2007.05.01-ний өдөр ашиглалтад оруулахаар гэрээндээ тусгасан боловч хугацаандаа ашиглалтад ороогүй бөгөөд энэ нь бидний хооронд байгуулсан гэрээний 4.1-ийн А-д барилгыг ашиглалтад оруулахаар тохиролцсон хугацаа хожимдуулсан нөхцөлд хугацаа хэтэрсэн сар тутамд нийт үнийн дүнгийн 0.5%-р алданги тооцож захиалагчид төлөх ёстой гэсэн заалт нь хэрэгжээгүй. 2008 оны 01 дүгээр сарын 07-ны өдөр ........... компани нь 05/007 тоот мэдэгдэл ирүүлж гэрээний 4.2 дахь заалтыг зөрчин гэрээг шинэчлэхийг мэдэгдсэн. Энэхүү мэдэгдэл нь хууль бус учир иргэн Н.М намайг Хан-Уул дүүргийн 20 дугаар хорооны нутаг дэвсгэрт байрлах ........ орон сууцны хотхоны 50м2 талбайтай 2 өрөө орон сууцны өмчлөгчөөр тогтоож өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Орон сууц худалдаж авсан тухай баримт /нотариатаар баталгаажуулсан/
  3. Үл хөдлөх эд хөрөнгийн түүхчилсэн лавлагаа
  4. Кадастрын зураг
  5. Гэрч нарын тодорхойлолт /тодорхойлолт бичсэн хүний иргэний үнэмлэхийг тодорхойлолт дээр хуулбарлаж нотариатаар баталгаажуулсан байх/
  6. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    сураггүй: {
      title: "Сураггүй алга болсонд тооцуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: СураггүйАлгБолсТоцуТу,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                       Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Сураггүй алга болсонд тооцуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие нь нөхөр Б.Доржтой 1999 онд танилцаж, гэр бүл болсон. Бид 2003 оныг хүртэл хамт амьдарч байсан ба нөхөр маань 2003 оны 2 дугаар сард Оросын Холбооны Улс руу хувийн ажлаар яваад эргэж ирээгүй одоо хаана байгаа нь мэдэгдэхгүй сураг чимээгүй алга болсон. 2003 онд нөхрийгөө алга болсон талаар Цагдаагийн байгууллагад хандаж эрж хайсан боловч өнөөдрийг хүртэл хэл сураг гарсангүй. Энэ талаар нөхрийн маань эцэг, эх ч мэдэж байгаа иймд сураггүй алга болсонд тооцож өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Цагдаагийн байгууллагын тодорхойлолт
  3. Гэрлэлтийн гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  4. Б.Доржийн иргэний үнэмлэхийн хуулбар
  5. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар
  6. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    тэтгэлэг: {
      title: "Эцэг тогтоолгож, хүүхдийн тэтгэлэг гаргуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ХүүхдТэтгэлэгГаргуула,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                               Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Хариуцагч: Дундговь аймаг .... сум .... баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Эцэг тогтоолгож, хүүхдийн тэтгэлэг гаргуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие 1999 онд Б.Баттай танилцаж, гэр бүлийн харьцаатай байсан. Бидний дундаас 2001-02-02-нд хүү Г.Мандах төрсөн. Б.Батын иргэний үнэмлэх зөрчилтэй байсан учир бид гэрлэлтийн баталгаагүй, өөрийн гэсэн орон байргүй эцэг эхийндээ амьдарч байсан. Тэрээр хүүгээ 1 нас хүрсний дараагаас биднийг эргэж тойрох нь эрс багассан. Одоо хүү маань 6 настай. Би өөрийн гэсэн ажил төрөлгүй, хүү маань одоо сургуульд орох болсон учир 2001-02-02-нд төрсөн хүү Г.Мандахын төрсөн эцэг нь Б.Бат мөн болохыг тогтоож, Б.Батаас хүүхдийн тэтгэлэг гаргуулж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл 2%
  2. Хүүхдүүдийн төрсний гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  3. Хүүхэд бага насных бол эрүүл бойжиж байгаа талаарх өрхийн эмчийн тодорхойлолт, суралцдаг бол сургуулийн тодорхойлолт
  /Бага насны хүүхэд гэж 0-3 настай хүүхдийг хэлнэ/
  4. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар
  5. Багийн засаг даргын тодорхойлолт /ам бүлийн/
  6. Улсын тэмдэгтийн хураамж төлсөн
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    эрэнСурвалжлах: {
      title: "Эрэн сурвалжлах",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ЭрэнСурвалжлах,
      content: `Огноо                                                      Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Хариуцагчийг эрэн сурвалжлуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие Д.Тулгатай 2007 оны 02 дугаар сарын 15-нд зээлийн гэрээ байгуулж, 10.0 сая төгрөгийг сарын 5 хувийн хүүтэй, 3 сарын хугацаатай зээлдүүлсэн юм. Д.Тулга нь тухайн үед Булган сумын 3 дугаар баг Зг-7-15 тоотод оршин сууж, Хүнсний зах дээр махны ченж хийдэг байсан. Зээлийн гэрээ байгуулж мөнгөө зээлж авснаас хойш 2 сар хүүгээ төлөөд тэрнээс хойш огт мөнгө төлөөгүй. Эхэндээ 2 хоногийн дараа, 3 хоногийн дараа гээд л яваад байдаг байсан. Одоо хаана оршин сууж байгаа нь мэдэгдэхгүй байгаа учир Д.Тулгыг эрэн сурвалжилж оршин суугаа хаягийг нь тогтоож өгнө үү. Д.Тулгын эхнэр Орхон трейд ХХК-нд ажилладаг байсан. Төрсөн эгч нь 20-р 12 жилийн сургуульд багш хийдэг. Утас нь 99300200 гэсэн утастай. Иймд миний хүсэлтийг хангаж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Зээлийн гэрээ /гэх мэт/
  3. Иргэний үнэмлэхийн хуулбар
  4. Тухайн этгээдийн хамгийн сүүлд оршин сууж байсан газрын багийн Засаг даргын тодорхойлолт
  5. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    насБарсан: {
      title: "Нас барсанд тооцуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: НасБарсандТооцуулТуха,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                      Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: нас барсанд тооцуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие нь нөхөр Б.Доржтой 1999 онд танилцаж, гэр бүл болсон. Бид 2003 оныг хүртэл хамт амьдарч байсан ба нөхөр маань 2003 оны 2 дугаар сард нас барсан. Тухайн үед улсын бүртгэлийн байгууллагад бүртгүүлээгүй. Иймд нас барсны тогтоож өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Цагдаагийн байгууллагын тодорхойлолт
  3. Гэрлэлтийн гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  4. Б.Доржийн иргэний үнэмлэхийн хуулбар
  5. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар
  6. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    эрхЗүй: {
      title: "Эрх зүйн чадамжгүйд тооцуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ЭрхЗүйнЧадамжгТооцТу,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                                      Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Эрх зүйн чадамжгүйд тооцуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Галт сумын Иргэдийн Төлөөлөгчдийн хурлаас Монгол Улсын Их хурлын Сонгуулийн тухай хуулийн 6.5, Иргэний хуулийн 18.2, Иргэний хэрэг шүүхэд хянан шийдвэрлэх тухай хуулийн 141-143 дугаар зүйлд зааснаар Галт сумын 3 дугаар багийн иргэн Бат овогтой Доржийг эрх зүйн чадамжгүйд тооцсон шийдвэр гаргаж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Багийн Засаг даргын тодорхойлолт
  3. Сумын Иргэдийн Төлөөлөгчдийн хурлыг төлөөлж оролцох төлөөлөгчийг томилсон итгэмжлэл
  4. Шинжээч томилуулах тухай хүсэлт
  5. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    эдХөрөнгө: {
      title: "Эд хөрөнгө мөнгө гаргуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ",
        audio: ЭдХөрөнгөМөнГаргуулах,
      note: "*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
      content: `Огноо                                              Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Хариуцагч: Сэлэнгэ аймаг .... сум .... баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Эд хөрөнгө мөнгө гаргуулах тухай
  
  Нэхэмжлэлийн үндэслэл: А.Наран нь 2004 оны 4 дүгээр сарын 28-ны өдрөөс 2005 оны 04 дүгээр сарын 28-ны өдөр хүртэл 1 жилийн хугацаагаар 10 хувийн хүүтэй 990.0 мянган төгрөгийг төлөхөөр тохиролцож албан ёсны гэрээ байгуулж зээлж авсан юм. Гэвч зээлсэн мөнгөө хугацаандаа төлөхгүй намайг хохироож байна. Иймд, хариуцагч А.Нарангаас үндсэн зээл болох 990.0 төгрөг, хүү 1015.2 төгрөг, нийт 2005.2 сая төгрөгийг гаргуулж хохиролгүй болгож өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл 2%
  2. Зээлийн гэрээ /гэх мэт/
  3. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    эдХөрөнгөдУчруулсанГэмХор: {
      title: "Эд хөрөнгөд учруулсан гэм хорын төлбөр гаргуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ\n\n*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
        audio: ЭдХөУчрГэмХорТөлГарТу,
      content: `Огноо                                                                Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум .... баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Хариуцагч: Дундговь аймаг .... сум .... баг, .... дугаар байрны.......... ийн..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Эд хөрөнгөд учруулсан гэм хорын төлбөр гаргуулах тухай
  
  Нэхэмжлэлийн үндэслэл: А овогтой Б би 2020 оны 03 дугаар сарын 10-ны өдөр 00 цагийн үед Ниссан Марк-II маркийн 99-99 УБО дугаартай суудлын автомашинаар Баянзүрх дүүргийн 10-р хорооны нутаг дэвсгэрт "Сансарын колонкийн буудал"-аас Шархад, Их Засаг Дээд сургууль руу зүүн чиглэлд аюулгүйн тойргийн 20-р эгнээгээр явж байх үед Тоёото Виста маркийн 80-80 УБУ дугаартай суудлын автомашины жолооч Р овогтой Г нь баруун чиглэлд явж байхдаа урд машинаа гүйцэт түрүүлэх үедээ эсрэг урсгалд орж миний машины урдаас мөргөсөн. Түүний буруутай үйлдлийн улмаас миний эзэмшлийн автомашинд ихээхэн хэмжээний хохирол учирсан. Р овогтой Г-ийн буруутай үйлдэл нь замын цагдаагийн газрын хэргийн газарт үзлэг хийсэн актаар тогтоогдож байгаа. Хохирлын хэмжээ бага тул эрүүгийн хэрэг үүсгэхээс татгалзаж энэ тухай прокурорын мэдэгдэл ирсэн. Миний машинд "Итгэлт-Эйстимэйт" ХХК-ийн үнэлгээгээр ... төгрөгийн хохирол учирсан. Энэ талаар бид ярьж тохиролцон Р овогтой Г нь учруулсан хохирлоо бүрэн төлж барагдуулахаар баталгаа гаргаж өгсөн боловч өнөөг хүртэл төлөхгүй байна. Би уг автомашинаар таксины үйлчилгээнд явж өдөрт 20000-30000 төгрөгийн орлого олдог. Иймд хариуцагч Р овогтой Г-ээс машинд учруулсан хохирол болох .... төгрөг, үнэлгээ хийлгэсний төлбөр .... төгрөг, бичиг баримт нотариатаар баталгаажуулсны төлбөр .... төгрөг, осол болсноос хойш өнөөдрийг хүртэлх хугацааны миний өөрийн олох ёстой байсан орлого болох ... хоногийн /1 хоног х 20000/ төлбөр .... төгрөг нийт .... төгрөгийг гаргуулж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Тээврийн хэрэгслийн гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  3. Ослын акт
  4. Хохирлын үнэлгээний акт
  5. Хариуцагч хохирлыг бүрэн төлж барагдуулах тухай баталгаа
  6. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар /нотариатаар баталгаажуулсан/
  7. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    насТогтоолгох: {
      title: "Нас тогтоолгох /төрсөн он, сар, өдөр зөвтгүүлэх тухай/",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ\n\n*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
        audio: НаТоТөрОнСарӨдЗөвтТух,
      content: `Огноо                                             Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Нас тогтоолгох /төрсөн он, сар, өдөр зөвтгүүлэх тухай/
  
  Нэхэмжлэлийн үндэслэл: Миний бие 1941 онд Хэнтий аймгийн Дархан суманд төрсөн. Гэтэл намайг бага байхад эцэг Дорж маань сургуульд оруулахгүй, мал дээрээ байлгана гээд 2 нас дарж, бүртгүүлж байсны улмаас одоо өндөр насны тэтгэврээ тогтоолгох нас хэтрээд байна. Иймд шүүхэд гаргаж өгсөн нотлох баримтуудыг үндэслэн намайг Хэнтий аймгийн Дархан 1941 онд төрсөн болохыг тогтоож, өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Үндэсний төв архиваас авсан хүн амын тооллогын бүртгэлийн лавлагаа /он, оноор/
  3. Улсын бүртгэлийн газрын лавлагаа
  4. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар /нотариатаар баталгаажуулсан/
  5. Төрсний гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  6. Гэрч нарын тодорхойлолт /тодорхойлолт бичсэн хүний иргэний үнэмлэхийг тодорхойлолт дээр хуулбарлаж нотариатаар баталгаажуулсан байх/
  7. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    улсынБүртгэл: {
      title: "Улсын бүртгэлд бүртгүүлэх тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ\n\n*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
        audio: УлсБүртгэлБүртгүүлТух,
      content: `Огноо                                             Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Улсын бүртгэлд бүртүүлэх тухай
  
  Нэхэмжлэлийн үндэслэл: Миний бие 1941 онд Хэнтий аймгийн Дархан суманд төрсөн. ........................... иргэний үнэмлэх, гадаад паспорт, жолооны үнэмлэх авсан. Гэтэл төрсний бүртгэлд бүртгэлгүй байх тул шүүхэд гаргаж өгсөн нотлох баримтуудыг үндэслэн намайг улсын бүртгэлийн төрсний бүртгэлд бүртгэж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. Үндэсний төв архиваас авсан хүн амын тооллогын бүртгэлийн лавлагаа /он, оноор/
  3. Улсын бүртгэлийн газрын лавлагаа
  4. Нэхэмжлэгчийн иргэний үнэмлэхийн хуулбар /нотариатаар баталгаажуулсан/
  5. Төрсний гэрчилгээний хуулбар /нотариатаар баталгаажуулсан/
  6. Гэрч нарын тодорхойлолт /тодорхойлолт бичсэн хүний иргэний үнэмлэхийг тодорхойлолт дээр хуулбарлаж нотариатаар баталгаажуулсан байх/
  7. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    нөхөнОлговор: {
      title: "Нөхөн олговор гаргуулах тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ\n\n*Нэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү.* Баярлалаа",
        audio: НөхөнОлговорГаргууТу,
      content: `Огноо                                                   Сайнцагаан сум
  
  Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны.......... ийн ..... тоотод оршин суух, А овогтой Б 
  Харилцах утас: /........ / эсхүл /ажлын газрын хаяг/
  
  Нэхэмжлэлийн шаардлага: Нөхөн олговор гаргуулах тухай
  
  Нэхэмжлэлийн үндэслэл: Миний өвөг эцэг Самбалхүндэвийн Чойдогжамц нь 1938 онд улс төрийн хэргээр баривчлагдан 1938 оны 2 дугаар сарын 25-нд онц бүрэн эрхт комиссын 7 дугаар хурлын тогтоолоор, Шүүх цаазын бичгийн 43-45 дугаар зүйлээр хуулийн дээд хэмжээгээр шийтгэгдэн, цаазлагдсаныг 1992-06-20-ны Дээд шүүхийн цэргийн Коллегийн 95-р магадлалаар цагаатгасан юм. Намайг Самбалхүндэвийн Чойдогжамцын ач хүү мөн болохыг сум дундын шүүхийн 2002 оны 11 дүгээр сарын 29-ны өдрийн 326 тоот шүүхийн шийдвэрээр тогтоосон юм. Иймд, Монгол Улсын Дээд шүүхийн цагаатгалын үнэмлэх, ТЕГ-ийн архивын лавлагаа, шүүхийн шийдвэр болон бусад нотлох баримтуудыг үндэслэн хэлмэгдэгч Самбалхүндэвийн Чойдогжамцын нөхөн олговрын 1000000 төгрөгийг гаргуулж өгнө үү.
  
  Нэхэмжлэлд хавсаргах баримт бичиг:
  1. Нэхэмжлэл
  2. 1992 оны Монгол Улсын Дээд шүүхийн цагаатгалын үнэмлэх
  3. Тагнуулын Ерөнхий газрын архивын лавлагаа
  4. Өв залгамжлах эрхийн гэрчилгээ
  5. Монгол Улсын Дээд Шүүхийн 95 дугаар магадлал
  6. Садан төрлийн холбоо тогтоолгосон шүүхийн шийдвэр
  7. Зууны мэдээ сонин
  8. Үндэсний төв архивын лавлагаа
  9. Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/
  
  Шүүхийн үйлчилгээний хэлтэс
  Утас: 7059-3016
  Вэб сайт: http://www.dundgovi-court.mn`,
    },
    бусдынХууль: {
      title: "Бусдын хууль бус эзэмшлээс газар чөлөөлүүлэх тухай",
      heading:
        "ДУНДГОВЬ АЙМАГ ДАХЬ СУМ ДУНДЫН АНХАН ШАТНЫ ШҮҮХЭД НЭХЭМЖЛЭЛ ГАРГАХ НЬ\n\nНэхэмжлэл бичихдээ урдаасаа үдэх зайтай буюу 3 см зай үлдээж бичнэ үү. Баярлалаа",
        audio: БусдХууБусЭзэмшГаЧөТу,
      content: `
Огноо                                              Сайнцагаан сум
Нэхэмжлэгч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны ..... ..... ийн ..... тоотод оршин суух, А овогтой Б
Харилцах утас: /.../.../... / эсхүл /ажлын газрын хаяг/
Хариуцагч: Дундговь аймаг .... сум ..... баг, .... дугаар байрны ..... ..... ийн ..... тоотод оршин суух, А овогтой Б
Харилцах утас: /.../.../... / эсхүл /ажлын газрын хаяг/
Нэхэмжлэлийн шаардлага: Бусдын хууль бус эзэмшлээс газар чөлөөлүүлэх тухай
Нэхэмжлэлийн үндэслэл: Н овогтой М миний бие нь Сүхбаатар сумын Засаг даргын 10 дугаар захирамжаар Сэлэнгэ аймгийн Сүхбаатар сумын 7 дугаар багт 2 дугаар хэсэгт байрлах газрыг эзэмшсэн юм. Гэтэл миний эзэмшил газарт А овогтой Б нь хууль бусаар эзэмшиж байгаа тул миний өмчлөл, эзэмшил газрыг чөлөөлж өгнө үү.
Нэхэмжлэлд хавсаргах баримт бичиг

Нэхэмжлэл
Газрын гэрчилгээ /нотариатаар баталгаажуулсан/
Кадастрын зураг
Улсын тэмдэгтийн хураамж төлсөн баримт /гүйлгээний утга: Улсын тэмдэгтийн хураамж ......-с/

Шүүхийн үйлчилгээний хэлтэс
Утас:7059-3016
Вэб сайт: http://www.dundgovi-court.mn
`,
    },
    журам: {
      title: "БУСАД ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА",
      heading: "Дундговь аймаг дахь сум дундын анхан шатны шүүх",
      content: ` 2025 оны .... сарын .... өдөр 					         	       Сайнцагаан
      БУСАД ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА
      /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа- А-15 маягт/
      1.	Нэхэмжлэлийн шаардлагын дүн: ........................................................................ төгрөг
      2.	Нэхэмжлэлийн шаардлагын үндэслэл: 
                ☐	Гэрээний үүргийн дагуу мөнгө гаргуулах 
                ☐	Гэрээний үүргээ гүйцэтгээгүйгээс учирсан хохирол гаргуулах 
                ☐  Гэрээг цуцалсан /татгалзсан/-аас учирсан хохирол гаргуулах 
                ☐	Гэрээний дагуу анз /алданги, торгууль/ гаргуулах
                ☐	Гэрээ байгуулагдаагүй, эсхүл хүчин төгөлдөр бус, эсхүл хүчин төгөлдөр бус гэж тооцуулах шаардлагын дагуу өгсөн мөнгөө буцааж гаргуулах, эсхүл өгсөн эд хөрөнгийн үнийг гаргуулах
                ☐	Гэрээ байгуулах бэлтгэл үе шатанд учруулсан хохирлыг гаргуулах 
                ☐	Бусад үндэслэлээр мөнгөн төлбөр гаргуулах
      3.	Та гэрээгээ бичгээр байгуулсан уу?
                                    ☐ Тийм 		
                                    ☐ Үгүй
      4.	Та өөрөө гэрээний үүргээ зохих ёсоор гүйцэтгэсэн үү?
                                    ☐ Тийм 		
                                    ☐ Үгүй
      5.	Гэрээ байгуулсан огноо: ..................................................................................................
      6.	Гэрээний хугацаа, дуусгавар болох огноо: ...................................................................
      7.	Гэрээний үүргийн зөрчил гарсан огноо: .......................................................................
      8.	Гэрээний зөрчлийн талаар нөгөө талд мэдэгдсэн огноо: ...........................................
      9.	Гэрээг цуцалсан, татгалзсан, хүчин төгөлдөр бус гэж тооцуулах талаар мэдэгдсэн 
      огноо: ...................................................................................................................
      10.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримтын талаар ач холбогдолтой гэж үзсэн нөхцөл байдлын талаар 300 үгэнд багтаан бичнэ үү.
      11.	Хавсаргасан баримтыг жагсаана уу.
      НЭХЭМЖЛЭЛ ГАРГАСАН:					/			/      `,
    },
    журам: {
      title: "ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА",
      heading: "/Шүүхийн нэр/-д",
      content: `  /Огноо/								                     /Газар/
      ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА
      /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа-А-2 маягт/ 
      1.	Нэхэмжлэлийн шаардлагын дүн:........................................................................ төгрөг

        (Таны шаардаж байгаа мөнгөн хөрөнгө хөдөлмөрийн хөлсний доод хэмжээг 20 
      дахин нэмэгдүүлснээс дээшгүй хэмжээтэй байх ёстой.)

            1.1.	Энэхүү дүнд:
                  Үндсэн зээл:   .................................................................... төгрөг
                  Хүү: ......................................................................................... төгрөг
                  Анз: /алданги, торгууль/  ....................................................... төгрөг
                  Бусад:...................................................................................... төгрөг

        (Хэрэв та тухайн шаардлагыг гаргаагүй бол харгалзах хэсэгт 0 дүн тавина уу)

      2.	Нэхэмжлэлийн шаардлагын үндэслэл:

                ☐ Зээлсэн мөнгөө буцаан гаргуулах
                ☐ Илүү төлсөн мөнгөө буцаан гаргуулах
                ☐ Учирсан хохирол гаргуулах
                ☐ Бусад

      3.	Дараах асуултад хариулна уу?
                3.1. Зээлийн гэрээг бичгээр байгуулсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                3.2. Зээлэхээр  тохирсон мөнгийг хүлээлцсэн үү?
                                ☐ Тийм
                                ☐ Үгүй /3.3-т хариулах шаардлагагүй/
                                ☐ Бүрэн биш
                3.3. Ямар хэлбэрээр хүлээлцсэн бэ?
                                ☐ Дансаар 
                                ☐ Бэлнээр
                3.4. Хүү төлөхөөр тохиролцсон уу?
                                ☐ Тийм
                                ☐ Үгүй
                3.5. Зээлийг буцаан төлөх хугацааг тохиролцсон уу?
                                ☐ Тийм
                                ☐ Үгүй /3.6, 3.8-д хариулах шаардлагагүй/
                3.6. Зээл буцаан төлөх хугацааг сунгаж байсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                3.7. Зээлийн төлөлт хийсэн үү?
                                ☐ Тийм
                                ☐ Үгүй /7, 8-д хариулах шаардлагагүй/
                3.8. Зээл төлөх хугацаа хэтэрсэн үү?
                                ☐ Тийм
                                ☐ Үгүй
                3.9. Зээлээ төлөхийг шаардаж байсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                3.10. Илүү төлөлт хийсэн үү?
                                ☐ Тийм 
                                ☐ Үгүй /3.11-т хариулах шаардлагагүй/
                3.11. Илүү төлөлтийг буцаах талаар нөгөө талдаа мэдэгдсэн үү? 
                                ☐ Тийм
                                ☐ Үгүй
                3.12.Зээлийн гэрээнд анз /торгууль, алданги/ төлөхөөр тохиролцсон  уу?
                                ☐ Тийм
                                ☐ Үгүй
      4.	Гэрээг байгуулсан огноо: .................................................................................................. 
      5.	Гэрээ дуусгавар болох огноо: ..........................................................................................
      6.	Гэрээний хугацааг сунгасан огноо: ................................................................................
      7.	Зээлийн буцаан төлөлт хийсэн огноо, төлөлт тус бүрийн дүн: ................................
            7.1. Буцаан төлөлт №1: ......
            7.2. Буцаан төлөлт №2: ...... 
            7.3. Буцаан төлөлт №3: ......    (гэх мэт)
      8.	Зээлийн нийт төлсөн дүн : ................................................................................................
      9.	Зээл гэрээний үүрэг зөрчигдөж эхэлсэн огноо: .........................................................
      10.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримт, зээл олголт, төлөлтийн 
      тооцооллын талаар ач холбогдолтой гэж үзсэн нөхцөл байдлын талаар 300 үгэнд 
      багтаан бичнэ үү. (Зээл олголт, төлөлтийн тооцоолол, огноог хүснэгтээр 
      харуулан хавсаргаж болно.)
      11.	Хавсаргасан баримтыг жагсаана уу.



                                    НЭХЭМЖЛЭЛ ГАРГАСАН:	
      `,
    },
    журам: {
      title: "ХУДАЛДАХ-ХУДАЛДАН АВАХ ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА",
      heading: "/Шүүхийн нэр/-д",
      content: `  /Огноо/								                     /Газар/
      ХУДАЛДАХ-ХУДАЛДАН АВАХ ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА
      /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа-А-1 маягт/ 
      1.	Нэхэмжлэлийн шаардлагын дүн:........................................................................ төгрөг

        (Таны шаардаж байгаа мөнгөн хөрөнгө хөдөлмөрийн хөлсний доод хэмжээг 20 
      дахин нэмэгдүүлснээс дээшгүй хэмжээтэй байх ёстой.)

            1.1.	Энэхүү дүнд:
                  Үндсэн зээл:   .................................................................... төгрөг
                  Анз: /алданги, торгууль/  ....................................................... төгрөг
                  Хохирол:  ........................................................................................................ төгрөг  
                  Бусад:...................................................................................... төгрөг

        (Хэрэв та тухайн шаардлагыг гаргаагүй бол харгалзах хэсэгт 0 дүн тавина уу)

      2.	Нэхэмжлэлийн шаардлагын үндэслэл:

                ☐ Худалдсан эд хөрөнгийн үнийг гаргуулах
                ☐ Шилжүүлсэн мөнгөө буцаан гаргуулах
                ☐ Эд хөрөнгийн доголдлыг арилгахад гаргасан зардал гаргуулах
                ☐ Анз гаргуулах
                ☐ Учирсан хохирол гаргуулах
                ☐ Бусад

      3.	Дараах асуултад хариулна уу?
                3.1. Зээлийн гэрээг бичгээр байгуулсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                3.2. Гэрээний зүйлийг хүлээлцсэн үү?
                                ☐ Тийм
                                ☐ Үгүй /3.3-т хариулах шаардлагагүй/
                                ☐ Бүрэн биш
                3.3.	Гэрээний зүйлийг тохирсон хугацаандаа өгсөн үү?
                                ☐ Тийм
                                ☐ Үгүй
                                ☐ Заримыг
                3.4.	Гэрээний зүйл дутагдал, доголдолтой байсан уу?
                                ☐ Тийм
                                ☐ Үгүй /8, 9-д хариулах шаардлагагүй/
                                ☐ Зарим нь
                3.5.	Гэрээний зүйлийн үнийг төлсөн үү?
                                ☐ Тийм
                                ☐ Үгүй /6-д хариулах шаардлагагүй/
                                ☐ Бүрэн биш
                3.6.	Анз, /алданги, торгууль/ төлүүлэхээр гэрээгээр тохиролцсон уу?
                                ☐ Тийм
                                ☐ Үгүй

      4.	Гэрээг байгуулсан огноо: .................................................................................................. 
      5.	Гэрээний үнэ: .....................................................................................................................
      6.	Худалдан авагч үнэ төлсөн огноо: ................................................................................. 
      7.	Гэрээний зүйлийг хүлээлцсэн огноо...............................................................................
      8.	Гэрээний зүйлийн дутагдал, доголдлыг илрүүлсэн огноо: ........................................
      9.	Дутагдал, доголдлын талаар нөгөө талдаа мэдэгдсэн огноо: ....................................
      10.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримтын талаар ач холбогдолтой 
      гэж үзсэн нөхцөл байдлын талаар 300 үгэнд багтаан бичнэ үү.
      11.	Хавсаргасан баримтыг жагсаана уу.




                                    НЭХЭМЖЛЭЛ ГАРГАСАН:	
      `,
    },
    журам: {
      title: "БУСДЫН ЭД ХӨРӨНГӨ, ЭРҮҮЛ МЭНДЭД ГЭМ ХОР УЧРУУЛСНЫ УЛМААС МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА",
      heading: "/Шүүхийн нэр/-д",
      content: `  /Огноо/								                     /Газар/
      БУСДЫН ЭД ХӨРӨНГӨ, ЭРҮҮЛ МЭНДЭД ГЭМ ХОР УЧРУУЛСНЫ УЛМААС МӨНГӨН 
                        ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА
        /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа-Б-3 маягт/
      1. Нэхэмжлэлийн шаардлагын дүн: ............................................................... төгрөг 

            (Таны шаардаж байгаа мөнгөн хөрөнгө хөдөлмөрийн хөлсний доод хэмжээг 20 
      дахин нэмэгдүүлснээс дээшгүй хэмжээтэй байх ёстой.)
      2.	Эд хөрөнгөд учирсан хохирлын хэмжээ: ......................................................................
                2.1.	Гэм хор учирсан эд хөрөнгө таны өмчлөлийн эд хөрөнгө мөн эсэх?
                                ☐ Тийм
                                ☐ Үгүй 
      3.	Эрүүл мэндэд учирсан хохирлын хэмжээ: ..................................................................

                3.1.	Эмнэлэгт хэвтэж эмчлүүлсний төлбөр: ........................................................
                3.2.	Эм тарианы төлбөр: .......................................................................................
                3.3.	Шинжилгээ, оношилгооны төлбөр: ...............................................................
                3.4.	Асарч сувилах, нэмэгдэл хоолны төлбөр: ....................................................
                3.5.	Хиймэл эрхтний төлбөр: ................................................................................. 
                3.6.	Сувиллын газар сувилуулсны төлбөр: ........................................................... 
                3.7.	Та хөдөлмөр эрхэлж байсан уу?
                                  ☐ Тийм 
                                  ☐ Үгүй /3.10, 3.11, 3.12-р асуултад хариулахгүй байж болно/
                3.8.	 Хөдөлмөрийн чадвар алдсантай холбогдуулан тогтоолгосон тэтгэмжийн 
                дүн:..........................................................................................................................
                3.9.	Хөдөлмөрийн чадвараа алдсанаас дутуу авсан цалин хөлс, түүнтэй 
                адилтгах орлогын дүн:........................................................................................... 
                3.10.	Үйлдвэрлэлийн ослын улмаас нэхэмжилж буй төлбөрийн хэмжээ:
                .................................................................................................................................
                3.11.	Мэргэжлээс шалтгаалах өвчний улмаас нэхэмжилж буй төлбөрийн 
                хэмжээ: ...................................................................................................................
                3.12.	Хурц хордлогын улмаас нэхэмжилж буй төлбөрийн хэмжээ: 
                ................................................................................................................................

      4.	Хариуцагчаас мөнгөн хөрөнгө гаргуулах болсон үндэслэлийг сонгоно уу?
                ☐ Байгууллага, албан тушаалтан гэм хор учруулсан 
                                                                                                  (Б-3-1 маягтыг бөглөнө үү)
                ☐ Тээврийн хэрэгслийн ашиглалтаас гэм хор учирсан 
                                                                                                  (Б-3-2 маягтыг бөглөнө үү)
                ☐ Барилга байгууламж барих, ашиглах явцад гэм хор учирсан 
                                                                                                  (Б-3-3 маягтыг бөглөнө үү)
                ☐ Амьтан, эсхүл орчин тойрондоо аюултай үйл ажиллагаа болон орчин тойрондоо аюултай бусад зүйлээс гэм хор учирсан	  
                                                                                                  
                (Б-3-4 маягтыг бөглөнө үү)                                                                                                    
                ☐ Иргэний эрх зүйн чадамжгүй, зарим чадамжтай, бүрэн бус чадамжтай иргэн гэм хор учруулсан						                  
                                                                                                  (Б-3-5 маягтыг бөглөнө үү)

                ☐  Арван зургаан нас хүрээгүй хүнд гэм хор учирсан 
                                            (Б-3-6 маягтыг бөглөнө үү)

                ☐	Бараа, бүтээгдэхүүн, ажил, үйлчилгээний дутагдлын улмаас гэм хор учирсан
                                          (Б-3-7 маягтыг бөглөнө үү)

                ☐	Гэм хор учруулснаас төлсөн төлбөрөө буцаан гаргуулна. 
                ☐ Бусад
      5. Хэрэг хянан шийдвэрлэх ажиллагаатай холбоотой тодруулах асуулт:

                5.1.	Нэхэмжлэл гаргах үндэслэл болсон эрхийн актын төрлийг сонгоно уу? 
                                ☐ Шүүхийн шийдвэр	
                                ☐ Шийтгэх тогтоол
                                ☐ Шийтгэвэр
                                ☐ Захиргааны акт
                                ☐ Эрхийн акт байхгүй /5.2-т хариулах шаардлагагүй/
                                ☐ Бусад
                5.2.	Нэхэмжлэл гаргах үндэслэл болсон эрхийн актын огноо, дугаар: ................             
                5.3.	Шинжээчийн дүгнэлт гарсан эсэх?
                                ☐ Тийм
                                ☐ Үгүй /5.4-т хариулах шаардлагагүй/
                5.4.	Шинжээчийн дүгнэлтийн огноо, дугаар, хохирлын хэмжээ: ..........................
                5.5.	Эрүүл мэнд, эд хөрөнгөө даатгуулсан эсэх?
                                ☐ Тийм
                                ☐ Үгүй /5.6, 5.7, 5.8-д хариулах шаардлагагүй/
                5.6.	Даатгалын гэрээний дагуу нөхөх олговор авсан эсэх?
                                ☐ Тийм
                                ☐ Үгүй
                5.7.	Даатгалын гэрээ байгуулсан хугацаа, огноо, дугаар, даатгалын хувь: .....
                5.8.	Даатгалын байгууллагаас авсан нөхөн төлбөрийн хэмжээ:......................... 

      6.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримтын талаар ач холбогдолтой гэж 
      үзсэн нөхцөл байдлын талаар 300 үгэнд багтаан бичнэ үү. 

      7.	Хавсаргасан баримтыг жагсаана уу.

      ГАРЫН ҮСЭГ:

      `,
    },
    журам: {
      title: "БАНК, ЗЭЭЛИЙН ҮЙЛ АЖИЛЛАГАА ЭРХЛЭХ ЭРХ БҮХИЙ ЭТГЭЭДЭЭС ОЛГОСОН ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА",
      heading: "/Шүүхийн нэр/-д",
      content: `  /Огноо/								                     /Газар/
      БАНК, ЗЭЭЛИЙН ҮЙЛ АЖИЛЛАГАА ЭРХЛЭХ ЭРХ БҮХИЙ ЭТГЭЭДЭЭС ОЛГОСОН 
        ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА
                        
        /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа- А-3 маягт/
      1.	Нэхэмжлэлийн шаардлагын дүн: ...................................................................... төгрөг
            (Таны шаардаж байгаа мөнгөн хөрөнгө хөдөлмөрийн хөлсний доод хэмжээг 20 
      дахин нэмэгдүүлснээс дээшгүй хэмжээтэй байх ёстой.)
                1.1.	Энэхүү мөнгөн дүнд:
                      Үндсэн зээл: .............................................................................................төгрөг 
                      Зээлийн хүү: ............................................................................................төгрөг 
                      Нэмэгдүүлсэн хүү:....................................................................................төгрөг 
                      Бусад: .......................................................................................................төгрөг 
            (Хэрэв та тухайн шаардлагыг гаргаагүй бол харгалзах хэсэгт 0 дүн тавина уу)

      2.	Нэхэмжлэлийн шаардлагын үндэслэл: 
                ☐ Зээлийн гэрээний үүргийг гүйцэтгүүлэх
                ☐ Зээлийн гэрээг хугацаанаас өмнө цуцалж, мөнгөн хөрөнгө гаргуулах
                ☐ Учирсан хохирлыг гаргуулах
                ☐ Бусад
      3.	Зээлийн төлбөр гаргуулах шаардлагаа үндэслэж байгаа гэрээ нь дараах аль 
      төрлийн гэрээнд хамаарах вэ?

                ☐ Банктай байгуулсан зээлийн гэрээ
                ☐ Банк бус санхүүгийн байгууллагатай байгуулсан зээлийн гэрээ
                ☐ Цахим зээлийн гэрээ буюу цахим аппликейшн ашигласан гэрээ
                ☐ Бүртгэлтэй иргэнтэй байгуулсан зээлийн гэрээ

      4.	Тийм, Үгүй гэсэн хариултын аль нэгийг сонгоно уу?
                4.1. Зээлдүүлэгч нь зээлийн үйл ажиллагаа эрхлэх тусгай зөвшөөрөлтэй юу?			
                                ☐ Тийм 		
                                ☐ Үгүй
                4.2. Зээлийн гэрээг бичгээр байгуулсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                4.3. Цахим зээлийн гэрээ байгуулсан уу?
                                ☐ Тийм
                                ☐ Үгүй
                4.4. Зээлийн гэрээнд хүү төлөхөөр тохиролцсон уу?
                                ☐ Тийм
                                ☐ Үгүй 
                4.5. Зээлийн гэрээнд нэмэгдүүлсэн хүү тохиролцсон уу?
                                ☐ Тийм
                                ☐ Үгүй
                4.6. Зээлийн гэрээний хугацаа дууссан уу? 
                                ☐ Тийм
                                ☐ Үгүй /4.7-д хариулах шаардлагагүй/
                4.7. Зээлийн гэрээний хугацааг сунгасан уу?
                                ☐ Тийм
                                ☐ Үгүй
                4.8. Зээлийн гэрээний үүргээ биелүүлэхийг нөгөө талаасаа шаардсан уу?
                                ☐ Тийм
                                ☐ Үгүй

      5.	Гэрээ байгуулсан огноо: ..................................................................................................
      6.	Гэрээ дуусгавар болох огноо: .........................................................................................
      7.	Зээл буцаан төлсөн огноо:...............................................................................................
      8.	Хийсэн буцаан төлөлт бүрийн дүн:.................................................................................
      9.	Буцаан төлсөн нийт мөнгөн хөрөнгийн дүн:.................................................................
      10.	Зээлийн гэрээний үүрэг зөрчигдөж эхэлсэн огноо:...................................................
      11.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримт, зээл олголт, төлөлтийн 
      тооцооллын талаар ач холбогдолтой гэж үзсэн нөхцөл байдлын талаар 300 үгэнд 
      багтаан бичнэ үү. (Зээл олголт, төлөлтийн тооцоолол, огноог хүснэгтээр 
      харуулан хавсаргана уу.)
      12.	Хавсаргасан баримтыг жагсаана уу.



                        НЭХЭМЖЛЭЛ ГАРГАСАН:			
      `,
    },
    журам: {
      title: "АЖИЛГҮЙ БАЙСАН ХУГАЦААНЫ ДУНДАЖ ЦАЛИН ХӨЛСТЭЙ ТЭНЦЭХ ОЛГОВОР ГАРГУУЛАХ ШААРДЛАГА",
      heading: "/Шүүхийн нэр/-д",
      content: `  /Огноо/								                     /Газар/
      АЖИЛГҮЙ БАЙСАН ХУГАЦААНЫ ДУНДАЖ ЦАЛИН ХӨЛСТЭЙ ТЭНЦЭХ 
      ОЛГОВОР ГАРГУУЛАХ ШААРДЛАГА
                        
        /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа- Б-4 маягт/
      1.	Нэхэмжлэлийн шаардлага: ..................................................................................төгрөг 

                1.1.	Нэхэмжлэлийн шаардлагад хамаарах хугацаа: .......................................

                                              (Нэхэмжлэлийн шаардлагын үнийн дүн хамаарахгүй)
      2.	Нэхэмжлэл гаргах үндэслэл болсон шийдвэрийн огноо:

                2.1. Анхан шатны шүүхийн шийдвэрийн огноо, дугаар: .......................................
                2.2. Давж заалдах шатны шүүхийн магадлалын огноо, дугаар: ...........................
                2.3. Хяналтын шатны шүүхийн тогтоолын огноо, дугаар: .....................................
      3.	Дараах асуултад хариулна уу?

                3.1.	Та шүүхэд хандахаас өмнө ажилгүй байсан хугацааны дундаж цалин 
      хөлстэй тэнцэх олговрын талаар Хөдөлмөрийн эрхийн маргаан таслах комисс, сум, 
      дүүргийн хөдөлмөрийн эрхийн маргаан зохицуулах гурван талт хороонд хандсан эсэх? 	
                              ☐ Тийм, гэвч шийдвэрийг зөвшөөрөхгүй байна. 
                              ☐ Тийм, гэвч шийдвэрлэх боломжгүй гэсэн хариу өгсөн
                              ☐ Үгүй /4-р асуултад хариулах шаардлагагүй/
                3.2.	Шийдвэр гүйцэтгэх ажиллагаа явагдаж байгаа эсэх?
                              ☐ Тийм 		
                              ☐ Үгүй
                3.3.	Та нэхэмжлэл гаргах хугацааг хэтрүүлсэн үү?  
                              ☐ Тийм (шалтгаан, үндэслэлээ 6 дугаар хэсэгт тайлбарлана уу).
                              ☐ Үгүй 
                3.4.	Ажилд эгүүлэн томилогдсон эсэх?
                              ☐ Тийм 		
                              ☐ Үгүй /5-д хариулах шаардлагагүй/

      4.	Урьдчилан шийдвэрлэх журамтай холбоотой асуулт:

                4.1.	Хөдөлмөрийн эрхийн маргаан шийдвэрлэх байгууллагад хөдөлмөрийн 
      маргаан шийдвэрлүүлэх боломжгүй гэж үзсэн үндэслэл:.......................................................
      ..........................................................................................................
      ...........................................................................................................
                4.2.	Хөдөлмөрийн эрхийн маргаан таслах комисс, сум, дүүргийн хөдөлмөрийн 
      эрхийн маргаан зохицуулах гурван талт хорооны хариу өгсөн огноо:   ..................................

      5.	Ажилд эгүүлэн томилогдсон бол огноо: ......................................................................
      6.	Нэхэмжлэлийн шаардлага, үндэслэл, үйл баримтын талаар ач холбогдолтой гэж 
      үзсэн нөхцөл байдлын талаар 300 үгэнд багтаан бичнэ үү.

      7.	Хавсаргасан баримтыг жагсаана уу.



                              НЭХЭМЖЛЭЛ ГАРГАСАН:

      `,
    },
    журам: {
      title: "НЭХЭМЖЛЭЛ",
      heading: "Дундговь аймаг дахь сум дундын анхан шатны шүүх",
      content: `  2025 оны....сарын .....өдөр						                     Сайнцагаан
      НЭХЭМЖЛЭЛ
                        
        /Тусгайлсан журмаар хянан шийдвэрлэх ажиллагаа- I маягт/
      I. ЗОХИГЧИЙН МЭДЭЭЛЭЛ

            Нэхэмжлэгч: 
            Иргэний овог нэр/Хуулийн этгээдийн нэр, зохион байгуулалтын хэлбэр:
      ....................................................................................................................................................
            Оршин суух/байх хаяг:.....................................................................................................
      ....................................................................................................................................................
            Иргэний бүртгэлийн дугаар:............................................................................................
            Хуулийн этгээд бол регистрийн дугаар:  .......................................................................
            Цахим шуудангийн хаяг:..................................................................................................
            Утасны дугаар:.................................................................................................................
      /хэд хэдэн нэхэмжлэгчтэй бол нэхэмжлэгч тус бүрээр дээрх мэдээллийг өгч хавсаргана 
      уу/
            Хариуцагч:
            Иргэний овог нэр/Хуулийн этгээдийн нэр, зохион байгуулалтын хэлбэр:
            ...........................................................................................................................................
            Оршин суух/байх хаяг:..................................................................................................... 
      ....................................................................................................................................................
            Иргэний бүртгэлийн дугаар:.............................................................................................
            Хуулийн этгээд бол регистрийн дугаар:  .......................................................................
            Цахим шуудангийн хаяг:..................................................................................................
            Утасны дугаар: ................................................................................................................
      /хэд хэдэн хариуцагчтай бол хариуцагч тус бүрээр дээрх мэдээллийг өгч хавсаргана 
      уу/
      II.	 НЭХЭМЖЛЭЛИЙН ШААРДЛАГА:                    
                  ☐  Мөнгөн хөрөнгө гаргуулах /3.1, 3.2, IV, V, VI хэсгүүдэд хариулна уу/
            (Таны шаардаж байгаа мөнгөн хөрөнгө хөдөлмөрийн хөлсний доод хэмжээг 20 
      дахин нэмэгдүүлснээс дээшгүй хэмжээтэй байх ёстой.)
                  ☐  Барьцааны зүйлээс үүргийг хангуулах /3.2, V, VI хэсгүүдэд хариулна уу/
                  ☐  Шүүхийн шийдвэр гүйцэтгэх ажиллагааг хүчингүй болгуулах /3.3, V, VI хэсгүүдэд хариулна уу/

      III. МАРГААНЫ АГУУЛГА: 

            3.1. Хариуцагчаас мөнгөн хөрөнгө гаргуулах болсон үндэслэлийг сонгоно уу.

                  ☐ Хариуцагчтай байгуулсан гэрээ, хэлцлийн дагуу шаардаж байгаа мөнгөн 
                  хөрөнгө 			                (А-1-А-15 маягтаас тохирохыг бөглөнө үү)

                  ☐ Дундын өмчийн ашиглалт, засвар үйлчилгээний үнэ 
                                                                                                        (Б-1 маягтыг бөглөнө үү)

                  ☐ Хөдөлмөрийн гэрээний дагуу олгоогүй цалин хөлс (Б-2 маягтыг бөглөнө үү)

                  ☐ Эд хөрөнгө, эрүүл мэндэд учирсан гэм хор (Б-3 маягтыг бөглөнө үү)

                  ☐ Ажилд эгүүлэн тогтоосон хүчин төгөлдөр шүүхийн шийдвэрийг үндэслэн 
                  ажилгүй байсан хугацааны дундаж цалин хөлстэй тэнцэх олговор 								 
                                                                      (Б-4 маягтыг бөглөнө үү)

      3.2.	Барьцааны зүйлээс үүргийг хангуулах шаардлагын талаар тодруулна уу. 						
                  ☐  Мөнгө төлүүлэх ба барьцааны шаардлагыг хамт гаргаж байна.
                              (А-13 маягтыг бөглөнө үү)
                  ☐ Мөнгө төлөх шүүхийн шийдвэрийг өмнө нь гаргуулсан тул барьцааны   шаардлагыг дангаар нь гаргаж байна. 
                                (А-13 маягтыг бөглөнө үү)
                  ☐	Хариуцагч мөнгө төлөхийг зөвшөөрсөн боловч барьцааг зөвшөөрөхгүй байх тул барьцааны шаардлагыг дангаар нь гаргаж байна. 
                                      (А-13 маягтыг бөглөнө үү)
      3.3.	Шүүхийн шийдвэр гүйцэтгэх ажиллагаатай холбоотой дараах шаардлагыг гаргаж байна.

                  ☐ Хөрөнгийг битүүмжлэх, хураах ажиллагааны талаарх шаардлага 
                              (Б-5 маягтыг бөглөнө үү)
                  ☐ Хөрөнгийн үнэлгээ тогтоох ажиллагааны талаарх шаардлага
                              (Б-6 маягтыг бөглөнө үү)
                  ☐	Хөрөнгийг дуудлага худалдаанд оруулах ажиллагааны талаарх шаардлага
                                (Б-7 маягтыг бөглөнө үү)

      IV.	 ГЭРЭЭНИЙ МАРГААН: Мөнгөн хөрөнгө гаргуулах болон барьцааны үүргийг шаардах үндэслэл болсон гэрээ нь 
                  ☐ Худалдах-худалдан авах гэрээ 		 (А-1 маягтыг бөглөнө үү)

                  ☐ Зээлийн гэрээ 				 (А-2 маягтыг бөглөнө үү)

                  ☐ Банк ба банк бус санхүүгийн байгууллагын зээлийн гэрээ 									          (А-3 маягтыг бөглөнө үү)

                  ☐ Бэлэглэлийн гэрээ 			                      (А-4 маягтыг бөглөнө үү)

                  ☐ Эд хөрөнгө хөлслөх гэрээ 			          (А-5 маягтыг бөглөнө үү)

                  ☐ Түрээсийн гэрээ 				          (А-6 маягтыг бөглөнө үү)

                  ☐ Санхүүгийн түрээсийн гэрээ 		          (А-7 маягтыг бөглөнө үү)

                  ☐ Ажил гүйцэтгэх гэрээ 			         (А-8 маягтыг бөглөнө үү)

                  ☐ Даатгалын гэрээ 				         (А-9 маягтыг бөглөнө үү)

                  ☐ Мөнгөн хадгаламжийн гэрээ 		        (А-10 маягтыг бөглөнө үү)

                  ☐ Зуучлалын гэрээ 				        (А-11 маягтыг бөглөнө үү)
                    
                  ☐ Тээвэрлэлтийн гэрээ				       (А-12 маягтыг бөглөнө үү)

                  ☐ Барьцааны гэрээ  				       (А-13 маягтыг бөглөнө үү)

                  ☐ Хамтран ажиллах гэрээ			      (А-14 маягтыг бөглөнө үү)

                  ☐ Бусад гэрээ					      (А-15 маягтыг бөглөнө үү)

      V. Хэрэг хянан шийдвэрлэх ажиллагаатай холбоотой тодруулах асуулт:

            5.1.	Та хариуцагчийн оршин суугаа хаягийн дагуу шүүхэд нэхэмжлэл гаргаж байна 
      уу?
                                  ☐ Тийм
                                  ☐ Үгүй
            5.2.	Нэхэмжлэлд дурдсан үйл баримт, зохигчийн гэм буруугийн талаар хуулийн хүчин 
      төгөлдөр шүүхийн болон арбитрын шийдвэр байгаа юу?
                                ☐ Тийм
                                ☐ Үгүй
            5.3.	Маргаж байгаа зүйл болон түүний үндэслэлийн талаарх өөр хэргийг шүүх 
      шийдвэрлэж байгаа, эсхүл эрүүгийн журмаар шалгаж байгаа юу?
                                ☐ Тийм
                                ☐ Үгүй
            5.4.	Та хариуцагчтай эвлэрэн хэлэлцэх хүсэлтэй юу?
                                ☐ Тийм
                                ☐ Үгүй
            5.5.	Маргааныг эвлэрүүлэн зуучлал, эсхүл арбитраар шийдвэрлүүлэхээр тохиролцсон  уу?
                                ☐ Тийм
                                ☐ Үгүй
            5.6.	Шүүхээс гадуур урьдчилан шийдвэрлэх журмаар хуульд заасан байгууллагад хандсан уу?
                                ☐ Тийм
                                ☐ Үгүй
      VI.	 Нэхэмжлэлд хавсаргасан баримтын жагсаалтыг хавсаргана уу.  






                        ГАРЫН ҮСЭГ:	

      `,
    },
  };

  const navItems = [
    { id: "зээлийн", text: "Зээлийн гэрээний нэхэмжлэл" },
    { id: "ажилд", text: "Ажилд эргүүлэн тогтоолгох" },
    { id: "эвлэрүүлэн", text: "Эвлэрүүлэн зуучлалд өргөдөл гаргах" },
    {
      id: "гэрлэлт",
      text: "Гэрлэлт цуцлуулж, хүүхдийн асрамж, тэтгэлэг гаргуулах хүсэлт",
    },
    { id: "үүрэг", text: "Гэрээний үүрэг" },
    { id: "хамтын", text: "Хамтын амьдралтай байсныг тогтоолгох тухай" },
    { id: "ажилласанЖил", text: "Ажилласан жил тогтоолгох" },
    { id: "гүйцэтгэх", text: "Гүйцэтгэх хуудас бичүүлэх хүсэлт" },
    { id: "оронСууц", text: "Орон сууцны өмчлөгчөөр тогтоолгох тухай" },
    { id: "сураггүй", text: "Сураггүй алга болсонд тооцуулах тухай" },
    { id: "тэтгэлэг", text: "Хүүхдийн тэтгэлэг гаргуулах" },
    { id: "эрэнСурвалжлах", text: "Эрэн сурвалжлах" },
    { id: "насБарсан", text: "Нас барсанд тооцуулах тухай" },
    { id: "эрхЗүй", text: "Эрх зүйн чадамжгүйд тооцуулах тухай" },
    { id: "эдХөрөнгө", text: "Эд хөрөнгө мөнгө гаргуулах тухай" },
    {
      id: "эдХөрөнгөдУчруулсанГэмХор",
      text: "Эд хөрөнгөд учруулсан гэм хорын төлбөр гаргуулах тухай",
    },
    {
      id: "насТогтоолгох",
      text: "Нас тогтоолгох /төрсөн он, сар, өдөр зөвтгүүлэх тухай/",
    },
    { id: "улсынБүртгэл", text: "Улсын бүртгэлд бүртгүүлэх тухай" },
    { id: "нөхөнОлговор", text: "Нөхөн олговор гаргуулах тухай" },
    {
      id: "бусдынХууль",
      text: "Бусдын хууль бус эзэмшлээс газар чөлөөлүүлэх тухай",
    },
    { id: "журам",  text: "БУСАД ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "ХУДАЛДАХ-ХУДАЛДАН АВАХ ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "БУСДЫН ЭД ХӨРӨНГӨ, ЭРҮҮЛ МЭНДЭД ГЭМ ХОР УЧРУУЛСНЫ УЛМААС МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "БАНК, ЗЭЭЛИЙН ҮЙЛ АЖИЛЛАГАА ЭРХЛЭХ ЭРХ БҮХИЙ ЭТГЭЭДЭЭС ОЛГОСОН ЗЭЭЛИЙН ГЭРЭЭНИЙ ДАГУУ МӨНГӨН ХӨРӨНГӨ ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "АЖИЛГҮЙ БАЙСАН ХУГАЦААНЫ ДУНДАЖ ЦАЛИН ХӨЛСТЭЙ ТЭНЦЭХ ОЛГОВОР ГАРГУУЛАХ ШААРДЛАГА"},
    { id: "журам",  text: "НЭХЭМЖЛЭЛ"},
  ];

  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 z-0">
        <Lottie
          animationData={background}
          loop
          autoplay
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className="relative z-10">
        <header
          className="bg-blue-600 text-white"
          style={{ backgroundColor: "#21396c" }}
        >
          <div className="container mx-auto px-4">
            <nav className="flex justify-between py-3">
              <div className="flex items-center space-x-4">
                <img
                onClick={() => navigate("/home")}
                  src={logo}
                  alt="DAN System Logo"
                  className="mb-4"
                  style={{ width: "200px", height: "50px" }}
                />
              </div>
              <div className="flex items-center space-x-6">
                <div className="relative" ref={dropdownRef}>
                  <button
                    className="flex items-center space-x-1 px-4 py-2 rounded-lg bg-blue-700 transition-colors"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <span>Үйлчилгээнүүд</span>
                    <ChevronDown size={16} className={`transform transition-transform ${showDropdown ? 'rotate-180' : ''}`} />
                  </button>
                  
          {showDropdown && (
            <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg py-2 z-50">
              {menus.map((menu, index) => (
                <button
                  key={index}
                  className="w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 transition-colors"
                  onClick={() => {
                    handleMenuClick(menu)
                  }}
                >
                  {menu.name}
                </button>
              ))}
                    </div>
                  )}
                </div>
              </div>
            </nav>
          </div>
        </header>

        <div className="flex min-h-screen">
          {/* Left Sidebar */}
          {/* <aside className="w-64 bg-white shadow-sm p-4 border-r fixed top-0 left-0 h-screen">
            <h2 className="font-bold text-lg mb-4 border-b pb-2">
              Загварын нэр
            </h2>
            <ul className="list-none p-0" style={{ maxHeight: "100vh" }}>
              {navItems.map((item) => (
                <li
                  key={item.id}
                  onClick={() => setActiveSection(item.id)}
                  className={`cursor-pointer p-2 rounded transition-colors duration-200 ${
                    activeSection === item.id
                      ? "text-[#0189ff]"
                      : "text-black hover:bg-gray-100"
                  }`}
                  style={{ textDecoration: "none" }}
                >
                  {item.text}
                </li>
              ))}
            </ul>
          </aside> */}

          {/* Main Content */}
          <div className="flex-1 bg-white">
            {/* Document Header */}
            <div className="p-4 border-b flex justify-between items-center">
              <div style={{ marginLeft: "20vw" }}>
                <h2>
                  {transcript
                    ? "Дуу хоолойгоор хайсан : " + transcript
                    : "Хайлт : " + selectedOption}
                </h2>
              </div>
              <div className="flex gap-4 items-center">
                <button
                  className="flex items-center gap-2 px-4 py-2"
                  onClick={togglePlay}
                >
                  {isPlaying ? <Pause size={20} /> : <AudioLines size={20} />}
                  {isPlaying ? 'Зогсоох' : 'Сонсох'}
                </button>
                <button
                  className="flex items-center gap-2 px-4 py-2 text-[#21396C]"
                  onClick={handleEmailClick}
                >
                  <Mail size={20} />
                  Илгээх
                </button>
                <button
                  className="flex items-center gap-2 px-4 py-2"
                  onClick={() => handlePrint()}
                >
                  <Printer size={20} />
                  Хэвлэх
                </button>
              </div>
            </div>

            {/* Document Content */}
            <div className="p-8 bg-white">
              <div
                className="max-w-4xl mx-auto"
                style={{
                  padding: "30mm 15mm 20mm 30mm",
                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "12px",
                  lineHeight: "1.5",
                }}
              >
                <div className="text-right italic mb-5">
                  <strong>Загварын нэр:</strong> {sections[activeSection].title}
                </div>

                <div className="text-right mb-8" style={{ fontSize: "12px" }}>
                  {sections[activeSection].heading}
                </div>

                <div className="whitespace-pre-wrap">
                  {sections[activeSection].content}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showEmailDialog && (
        <EmailDialog setShowEmailDialog={setShowEmailDialog} />
      )}
    </div>
  );
};

export default DocumentTemplate;
